var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.7 25.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.07,4.14l.33.4c.31.42.6,1.21.18,1.6S9.06,6.2,8.5,6c-1.43-.39-1.9,1.17-3.64-.56-.15.1-.06,0-.22.19a3.73,3.73,0,0,0-.8,2.83c.18,1.63,2.75,4.54,4,8.25,2.27-.72,2.79-3.31,7-4,2.46-.4.4.27,3.08-2.43A11.11,11.11,0,0,1,21.14,8c3.48-1.69,5.41-1.89,6.92,1.62a7.7,7.7,0,0,1-1.48,8.4c-2.09,2.18-2.32.52-4,1.49-1,.56-2,3.69-6.52,4.48-1.73.31-3.58.09-5.21.41s-3,.6-4.65.85c-5.16.81-3.79-.4-4.86-2.92a13.65,13.65,0,0,1-.82-1.93c-1-3.56-.23-9.35-.28-13.11,0-1.92-.2-3.44,1-4.64S3.19,1.48,5.19.85C9.13-.4,7.24-.4,9.82,1.72c.83.68,1.87,1.83.25,2.42Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF8);
export default __webpack_public_path__ + "static/media/F8.7af9d1c971d55827e0cdde40ca1ef1c6.svg";
export { ForwardRef as ReactComponent };